//Content.js
import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import HomePage from '../waves/HomePage';
import {globalConfig} from '../../config/config';

function HomepageWaves()
{
        return (
        <>
       	<HomePage />
        {/*
         	<iframe width="100%" frameborder="false" height="900" src={globalConfig.wavesUrl} />
        */}
        </>
		)
}
export default HomepageWaves;

